module.exports = __webpack_public_path__ + "53536469.svg";